module.exports = __webpack_public_path__ + "img/logo-99-empresas-82x68.e1dc8871.png";